<!-- =========================================================================================
	File Name: TheNavbar.vue
	Description: Navbar component
	Component Name: TheNavbar
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="cs-navbar-wrapper">
    <vs-navbar class="cs-navbar navbar-custom" :color="navbarColor" :class="classObj">
      <!-- LOGO -->
      <div class="brand">
        <img
          v-if="
            company &&
            company.logo_url !== '' &&
            company.logo_url !== undefined &&
            company.logo_url !== null
          "
          class="logo_img mx-4"
          :src="company.logo_url"
          alt="company logo"
        />
        <h2 v-else-if="isAnonimous">
          Empresa Anônima
        </h2>        
        <h2 v-else>
          {{ company.name }}
        </h2>
      </div>

      <vs-spacer></vs-spacer>

      <div class="steps-navbar__vacancy">
        
      </div>

      <vs-spacer></vs-spacer>

      <!-- USER META -->
      <div class="the-navbar__user-meta flex items-center mobile-hidden">
        <div class="text-right leading-tight hidden sm:block">
          <p class="font-semibold text-base mb-0">{{ name }}</p>
        </div>
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <div class="con-img mx-4">
            <img
              v-if="
                basicInfo.photo_url !== undefined &&
                basicInfo.photo_url !== '' &&
                basicInfo.photo_url !== null
              "
              :src="basicInfo.photo_url"
              alt="user-img"
              key="online-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
            <img
              v-else
              src="@/assets/images/portrait/small/avatars1.png"
              alt="user-img"
              key="local-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
          </div>
          <vs-dropdown-menu class="vx-navbar-dropdown">
            <ul style="min-width: 9rem">
              <li
                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                @click="doLogout()"
              >
                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                <span class="ml-2">Logout</span>
              </li>
            </ul>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </vs-navbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "the-steps-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      searchQuery: "",
      showFullSearch: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      company: {
        name: "",
        logo_url: undefined,
      },
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false;
    },
  },
  computed: {
    ...mapState("progress", ["progress"]),
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("auth", ["isUserLoggedIn"]),
    ...mapState("vacancy", ["vacancy"]),
    ...mapGetters("company", ["hasCompanyInfo"]),

    name: {
      get() {
        return this.basicInfo.name || "";
      },
    },

    avatar: {
      get() {
        if (this.basicInfo.hasOwnProperty("photo_url")) return this.basicInfo.photo_url;
      },
    },
    isAnonimous() {
      const { company_label } = this.$router.history.current.params;
      return company_label === "anonima";
    },
  },
  methods: {
    ...mapActions("basicInfo", ["clearBasicInfoState"]),
    ...mapActions("address", ["clearAddressState"]),
    ...mapActions("experience", ["clearExperienceState"]),
    ...mapActions("language", ["clearLanguageState"]),
    ...mapActions("formation", ["clearFormationState"]),
    ...mapActions("skill", ["clearSkillState"]),
    ...mapActions("step", ["clearStepsState"]),
    ...mapActions("vacancy", ["updateVacancy"]),

    async doLogout() {
      if (this.isUserLoggedIn) {
        localStorage.clear();
        sessionStorage.clear();
        this.clearBasicInfoState();
        this.clearAddressState();
        this.clearExperienceState();
        this.clearLanguageState();
        this.clearFormationState();
        this.clearSkillState();
        this.clearStepsState();

        this.$store.dispatch("updateTab", 1);

        const params = this.$router.history.current.params;
        this.$router.push({ name: "signin", params: { ...params } });
      }
    },
    async fetchCompany() {
      try {
        const { company_label, vacancy_id } = this.$router.history.current.params;

        if (company_label && vacancy_id) {
          const response = await this.$http.get(
            `/api/v2/companies/${company_label}/${vacancy_id}`
          );

          const { name, logo_url, vacancy } = response.data.data;

          this.company = { ...this.company, name, logo_url };
          this.updateVacancy(vacancy);

          // Identify customer
          woopra.identify({
            company: name,
          });

          // track
          // woopra.track();
        }

        if (company_label) {
          const response = await this.$http.get(`/api/v2/companies/${company_label}`);

          const { name, logo_url } = response.data.data;

          this.company = { ...this.company, name, logo_url };

          // Identify customer
          woopra.identify({
            company: name,
          });

          // track
          // woopra.track();
        }
      } catch (error) {
        error;
      }
    },
  },
  created() {
    this.fetchCompany();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/layout/stepsNavbar.scss";

.brand {
  h2 {
    margin-left: 1rem;
    color: #252525;
    text-align: center;
    font-family: Roboto;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.52px;
  }
}

.steps-navbar__vacancy {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.steps-navbar__title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #2c2c2c;
  opacity: 1;
}

.steps-navbar__description {
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #2c2c2c;
  opacity: 1;
}

.truncate {
  width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: 1020px) {
    width: 400px;
  }
}
</style>
